import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (max-width: 992px) {
    max-width: 960px;
  }

  @media (max-width: 768px) {
    max-width: 720px;
  }

  @media (max-width: 576px) {
    max-width: 540px;
  }

  ${({ narrow }) =>
    narrow &&
    css`
      @media (min-width: 577px) {
        max-width: 570px;
      }
    `}

  ${({ paddingBottom }) =>
    paddingBottom &&
    css`
      padding-bottom: 146px;

      @media (max-width: 767px) {
        padding-bottom: 100px;
      }
    `}

  ${({ paddingTop }) =>
    paddingTop &&
    css`
      padding-top: 150px;

      @media (max-width: 767px) {
        padding-top: 95px;
      }
    `}
`;
